<template>
  <v-app id="ruta-estado-maquina" light class="ruta-estado-maquina-page">
    <v-main class="pa-0">
      <v-container v-if="loadingLogin || loginError" fluid class="login-state login-state--inline">
        <v-alert
          v-if="loadingLogin"
          type="info"
          outlined
          dense
          class="login-state__alert"
        >
          Iniciando sesion automaticamente...
        </v-alert>
        <v-alert
          v-else-if="loginError"
          type="warning"
          outlined
          dense
          class="login-state__alert"
        >
          {{ loginErrorMessage }}
        </v-alert>
      </v-container>

      <EstadoMaquinaCazels />
    </v-main>
  </v-app>
</template>

<script>
import EstadoMaquinaCazels from '@/components/DashViews/Reportes/EstadoMaquinaCazels.vue'

const HARD_CODED_USERNAME = 'reportes@reportes.com'
const HARD_CODED_PASSWORD = '12345678'

export default {
  name: 'RutaEstadoMaquina',
  components: {
    EstadoMaquinaCazels
  },
  data: () => ({
    loadingLogin: true,
    loginError: '',
    loginInterval: null,
    loginInProgress: false,
    retryCountdown: 0,
    retryCountdownInterval: null
  }),
  computed: {
    loginErrorMessage() {
      if (!this.loginError) return '';
      return `${this.loginError} ${this.retryCountdownLabel}`.trim();
    },
    retryCountdownLabel() {
      if (this.retryCountdown <= 0) return 'Se reintentara ahora.';
      return `Se reintentara en ${this.formatCountdown(this.retryCountdown)}.`;
    }
  },
  mounted() {
    this.autoLogin()
    this.loginInterval = setInterval(() => {
      this.autoLogin()
    }, 120000)
  },
  beforeDestroy() {
    if (this.loginInterval) {
      clearInterval(this.loginInterval)
      this.loginInterval = null
    }
    this.stopRetryCountdown()
  },
  methods: {
    formatCountdown(totalSeconds) {
      const total = Math.max(0, Number(totalSeconds) || 0)
      const minutes = Math.floor(total / 60)
      const seconds = total % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    startRetryCountdown(seconds = 120) {
      this.stopRetryCountdown()
      this.retryCountdown = Math.max(0, Number(seconds) || 0)
      this.retryCountdownInterval = setInterval(() => {
        if (this.retryCountdown > 0) {
          this.retryCountdown -= 1
          return
        }
        this.stopRetryCountdown()
      }, 1000)
    },
    stopRetryCountdown() {
      if (this.retryCountdownInterval) {
        clearInterval(this.retryCountdownInterval)
        this.retryCountdownInterval = null
      }
      this.retryCountdown = 0
    },
    async autoLogin() {
      if (this.loginInProgress) return
      this.loginInProgress = true
      this.loadingLogin = true
      this.loginError = ''
      this.stopRetryCountdown()

      try {
        const height = window.screen.availHeight
        const width = window.screen.availWidth
        const response = await this.$store.dispatch('login', {
          username: HARD_CODED_USERNAME,
          password: HARD_CODED_PASSWORD,
          height,
          width
        })

        if (response === 'double_factor_required') {
          this.loginError = 'La cuenta requiere doble factor y esta ruta no lo soporta.'
          return
        }

        if (response !== 'auth_success') {
          this.loginError = 'No se pudo autenticar automaticamente.'
          return
        }
      } catch (error) {
        this.loginError = 'No se pudo iniciar sesion automaticamente.'
        this.startRetryCountdown(120)
        console.log(error)
      } finally {
        this.loadingLogin = false
        this.loginInProgress = false
      }
    }
  }
}
</script>

<style scoped>
.ruta-estado-maquina-page {
  background: #f4f6f9;
}

.login-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  padding: 12px 12px 0;
}

.login-state--inline {
  min-height: 0;
}

.login-state__alert {
  width: 100%;
  margin-bottom: 12px;
}
</style>
